<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="intro-dedication-text">This book is dedicated to the suffering addict. And to Van’s House…thanks for all you do!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB-3.vue?14c263dc